import { ApplicationSimplifyModule } from './modules/application-simplify/application-simplify.module';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { FormAppelComponent } from './components/form-appel/form-appel.component';
import { AuthGuard } from './service/authgard/auth.gard';
import { DeliberationComponent } from './modules/appels/components/deliberation/deliberation.component';
import { AdmisComponent } from './modules/appels/components/admis/admis.component';
import { NonadmisComponent } from './modules/appels/components/nonadmis/nonadmis.component';
import { DashBoardSiguiComponent } from './modules/main-layout/components/dash-board-sigui/dash-board-sigui.component';

import { ConfirmationComponent } from './components/confirmation/confirmation.component';
import { UserNotFoundComponent } from './components/usernot-found/usernot-found.component';
import { SuccessCandidatureComponent } from './components/success-candidature/success-candidature.component';
import { StemdFormComponent } from './components/stemd-form/stemd-form.component';
import { InviteFormComponent } from './components/invite-form/invite-form.component';
import { FormAppelOneFamilyComponent } from './components/form-appel-one-family/form-appel-one-family.component';
import { FormAppelHorsParcoursComponent } from './components/form-appel-hors-parcours/form-appel-hors-parcours.component';
import { ConfirmationHorsParcoursComponent } from './components/confirmation-hors-parcours/confirmation-hors-parcours.component';
import { FormMultiAppelComponent } from './components/form-multi-appel/form-multi-appel.component';
import { FormAppelImprovedComponent } from './components/form-appel-improved/form-appel-improved.component';
import { JpoFormComponent } from './components/jpo-form/jpo-form.component';
import { FormCandidatureMentoratComponent } from './modules/mentorat/components/form-candidature-mentorat/form-candidature-mentorat.component';
import { ConfirmationMentoratComponent } from './modules/mentorat/components/confirmation-mentorat/confirmation-mentorat.component';
import { MiniJpoFormComponent } from './components/mini-jpo-form/mini-jpo-form.component';
import { ActivityConfirmationFormComponent } from './components/activity-confirmation-form/activity-confirmation-form.component';
import { MaintenanceFormComponent } from './maintenance/maintenance-form/maintenance-form.component';
import { ActivityQrcodeConfirmationFormComponent } from './components/activity-qrcode-confirmation-form/activity-qrcode-confirmation-form.component';
import { FormPartnersComponent } from './modules/partners/form-partners/form-partners.component';
import { ConfirmationpartnComponent } from './modules/partners/confirmationpartn/confirmationpartn.component';
import { FormAppelSimplifyComponent } from './modules/application-simplify/form-appel-simplify/form-appel-simplify.component';
import { ConfirmationSimplifyComponent } from './modules/application-simplify/confirmation-simplify/confirmation-simplify.component';
import { FormationFormComponent } from './components/formation-commercants-form/formation-form.component';
import { PortailappelformComponent } from './components/portailappelform/portailappelform.component';
import { FormMultiAppelCdpComponent } from './components/form-multi-appel-cdp/form-multi-appel-cdp.component';
import { FormAppelImprovedCdpComponent } from './components/form-appel-improved-cdp/form-appel-improved-cdp.component';
import { BootcampConfirmationComponent } from './components/bootcamp-confirmation/bootcamp-confirmation.component';
import { ActivityAttendanceComponent } from './components/activity-attendance/activity-attendance.component';

const routes: Routes = [
  {
    path: 'appelmentorat',
    component: FormCandidatureMentoratComponent,
  },
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },

  /*  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.module').then((module) => module.AuthModule),
  }, */
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./modules/main-layout/main-layout.module').then(
        (module) => module.MainLayoutModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'confirmation/:iuf/:cohorte',
    component: ConfirmationComponent,
  },
  {
    path: 'confirmation/:iuf/:cohorte/:status',
    component: ConfirmationHorsParcoursComponent,
  },
  {
    path: 'activity/confirmation/:idActivity/:idInvite',
    component: InviteFormComponent,
  },
  // ===== DÉBUT AJOUT : nouveau lien du mail (jeton secret) =====
  {
    path: 'activity/invitation/:token',
    component: InviteFormComponent,
  },
  // ===== FIN AJOUT =====

  {
    path: 'activity/jpo/confirmation/:idActivity/:iuf',
    component: ActivityConfirmationFormComponent,
  },
  {
    path: 'activity/confirmation/:idActivity',
    component: ActivityQrcodeConfirmationFormComponent,
  },
  {
    path: 'activity/bootcamp/confirmation/:idActivity/:iuf',
    component: BootcampConfirmationComponent,
  },
  {
    path: 'activity/inscription/:type',
    component: MiniJpoFormComponent,
  },
  {
    path: 'activity/:activiteId/formationcom/inscription',
    component: FormationFormComponent,
  },
  {
    path: 'activity/bootcamp/presence/:idActivity/:iuf',
    component: ActivityAttendanceComponent,
  },

  // {
  //   path: 'sigui/candidature/sig2408',
  //   component: FormAppelComponent,
  // },
  {
    path: 'sigui/candidature/sig2408/reussie',
    component: SuccessCandidatureComponent,
  },
  {
    path: 'sigui/candidature/SIG2610',
    component: FormAppelImprovedComponent,
  },
  {
    path: 'sigui/candidature/SIG2610/reussie',
    component: SuccessCandidatureComponent,
  },
  {
    path: 'sigui/candidatures/2026',
    component: FormAppelImprovedCdpComponent,
  },
  //################ Hors SIGUI WITHOUT PARAM ################
  // {
  //   path: 'horsigui/fode/candidature/:cohorte/:partener',
  //   component: FormAppelHorsParcoursComponent,
  // },

  //################ Parteners URL OR Provious multiple ################

  {
    path: 'sigui/stmd/inscription',
    component: StemdFormComponent,
  },

  //################ MULTI APPEL ################
  {
    // path: 'horsigui/candidature/:cohorte/:params',
    path: 'horsigui/fode/:pays/:params',
    component: PortailappelformComponent,
  },
  {
    // path: 'horsigui/candidature/:cohorte/:params',
    path: 'horsigui/fode/candidature/:cohorte/:params',
    component: FormMultiAppelComponent,
  },
  {
    path: 'horsigui/:cohorte/:fode',
    component: FormMultiAppelCdpComponent,
  },
  {
    path: 'horsigui/candidature/:cohorte/reussie/:params',
    component: SuccessCandidatureComponent,
  },
  //################ END MULTI APPEL ################

  //################ PARTNER ACCOMPAGNEMENT ################
  {
    path: 'accompagnement/enrollement/partenaire/FODE',
    component: FormPartnersComponent,
  },
  {
    path: 'candidature/enrollement/reussie',
    component: ConfirmationpartnComponent,
  },
  //################ END PARTNER ACCOMPAGNEMENT ################
  //################ MAINTENACE ################
  // {
  //   path: 'horsigui/candidature/HSIG2510-FODE/:params',
  //   component: MaintenanceFormComponent,
  // },

  //################ MENTORAT ################
  {
    path: 'mentorat/candidature/appel/:cohorte',
    component: FormCandidatureMentoratComponent,
  },
  {
    path: 'mentorat/candidature/:cohorte/reussie/:params',
    component: SuccessCandidatureComponent,
  },
  {
    path: 'confirmation/mentorat/:iuf/:cohorte/:status',
    component: ConfirmationMentoratComponent,
  },

  /* {
    path:'deliberation',
    component:DeliberationComponent
  },
  {
    path:'liste-des-admis',
    component:AdmisComponent
  },
  {
    path:'liste-des-non-admis',
    component:NonadmisComponent
  },
  {
    path:'dashSigui',
    component:DashBoardSiguiComponent
  }, */
  // Partenaire
  {
    path: 'partenaire',
    loadChildren: () =>
      import('./modules/partners/partners.module').then(
        (m) => m.PartnersModule,
      ),
  },

  //### Appel simplifie
  {
    path: 'candidature/application-simplify/:cohorte/:params',
    component: FormAppelSimplifyComponent,
  },
  {
    path: 'confirmationappelsimp/application-simplify/:cohorte/:params',
    component: ConfirmationSimplifyComponent,
  },

  //### End appel simplifie

  {
    path: 'usernotfound',
    component: UserNotFoundComponent,
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
